import styled from '@emotion/styled';
import { css } from '@emotion/core';

import type { PopoverPlacement } from './types';

type Props = {
  color: string;
  placement: PopoverPlacement;
};

const Arrow = styled('div')(
  css`
    width: 0;
    height: 0;
    border-width: 6px;
    border-style: solid;
    content: '';
    position: absolute;
  `,
  ({ placement, color }: Props) => {
    if (!placement) return null;
    if (placement.includes('top')) {
      return css`
        border-color: ${color} transparent transparent;
        top: 100%;
      `;
    }
    if (placement.includes('right')) {
      return css`
        border-color: transparent ${color} transparent transparent;
        right: 100%;
      `;
    }
    if (placement.includes('bottom')) {
      return css`
        border-color: transparent transparent ${color};
        bottom: 100%;
      `;
    }
    if (placement.includes('left')) {
      return css`
        border-color: transparent transparent transparent ${color};
        left: 100%;
      `;
    }
    return null;
  }
);

Arrow.defaultProps = {
  color: 'white',
  placement: 'bottom',
};

export default Arrow;
